module.exports = __webpack_public_path__ + "static/cotas-abarcones-milimetrico-6c57a83aa1ac31e576328001c60a43d1.pdf";